export async function checkAppVersion() {
    try {
        const response = await fetch('/version.json?t=' + Date.now());
        const data = await response.json();
        const oldVersion = localStorage.getItem('v1glo_frontend');
        if (oldVersion && oldVersion !== data.version) {
            if ('caches' in window) {
                const keys = await caches.keys();
                await Promise.all(keys.map(key => caches.delete(key)));
            }
            localStorage.clear();
            sessionStorage.clear();
            localStorage.setItem('v1glo_frontend', data.version);
            window.location.reload();
        }
        if (!oldVersion) {
            localStorage.setItem('v1glo_frontend', data.version);
        }
    } catch (error) {
        console.error('Version check failed:', error);
    }
}